import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=0fdd4312&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd4312')) {
      api.createRecord('0fdd4312', component.options)
    } else {
      api.reload('0fdd4312', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=0fdd4312&", function () {
      api.rerender('0fdd4312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-278xmOuTKBlO8/JS/pricehelp.vue"
export default component.exports